<div class="referral mt-3" *accessRoles="SEND_REFERRAL">
  <div class="row align-items-center">
    <div class="col-5 col-md-8">
      <p class="page-header">Send referral</p>

    </div>
    <div class="col-7 col-md-3 download-button" *ngIf="isBulkUpload">
      <button (click)="downloadTemplate()" type="button" class="btn btn-block btn-lg btn-greengo" npFocusOutClicked>
        Download Template
      </button>
    </div>
  </div>

  <form [formGroup]="uploadForm" *ngIf="isBulkUpload">
    <div class="row">
      <div class="col-12 col-md-4">
        <p class="details-title">
          Upload multiple leads (via Excel batch file)
        </p>
      </div>
    </div>
    <div class="row">
      <div class="offset-md-4 col-12 col-md-4">
        <div class="form-group up-referral">
          <mat-form-field class="up-file" [ngClass]="{'is-invalid': invalidFile}">
            <input matInput readonly formControlName="fileName" placeholder="File name">
            <span class="optional" *ngIf="notUploadFile()">Optional</span>
            <i *ngIf="!notUploadFile()" (click)="deleteFile()" class="material-icons button-delete">
              close
            </i>
          </mat-form-field>
          <div *ngIf="invalidFile">
            <p class="err-message">Invalid file</p>
          </div>
        </div>

      </div>
      <div class="col-12 col-md-3 upload-referral pl-md-0">
        <div class="upload-wrapper">
          <label class="upload-file">
            <input type="file" name="file" id="file" class="inputfile" (change)="onChange($event)" formControlName="file" accept=".xls,.xlsx, .csv"
            />
            <span class="inputfile-label">+</span>
          </label>
          <button [disabled]="notUploadFile()" (click)="uploadFile()" type="button" class="btn btn-block btn-lg btn-greengo" npFocusOutClicked>
            Upload
          </button>
        </div>
      </div>
    </div>
  </form>

  <form [formGroup]="fg" *ngIf="!isBulkUpload">
    <div class="row">
      <div class="col-12 col-md-4 mx-auto">
        <p class="save-error" *ngIf="isSavingFail">This referral already existed in the system.</p>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-md-4">
        <p class="details-title">
          Upload single lead (complete the form below)
        </p>
      </div>
    </div>
    <div class="row mb-1">
      <div class="col-12 col-md-4 mx-auto">

        <div class="form-group">
          <mat-form-field [ngClass]="{'is-invalid': leadTypeCtrl.hasError('required') && leadTypeCtrl.touched,
                'is-valid': leadTypeCtrl.valid && leadTypeCtrl.touched}">
            <mat-select formControlName="leadType" npDetectFocus #ipLT="detectFocus" placeholder="Lead type">
              <mat-option *ngFor="let leadType of leadTypes" [value]="leadType.id">
                {{leadType.name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <div *ngIf="leadTypeCtrl.hasError('required') && leadTypeCtrl.touched && !ipLT.isFocus">
            <p class="err-message">Please input information here</p>
          </div>
        </div>

        <div class="form-group " *ngIf="showIndustry">
          <mat-form-field [ngClass]="{'is-valid': companyNumberCtrl.valid && companyNumberCtrl.touched}">
            <input matInput formControlName="companyNumber" (keypress)="$event.charCode >= 48 && $event.charCode <= 57" placeholder="Company number">
            <span class="optional">Optional</span>
          </mat-form-field>
        </div>

        <div class="form-group" *ngIf="showIndustry">
          <mat-form-field [ngClass]="{'is-invalid': busCtrl.hasError('required') && busCtrl.touched,
            'is-valid':busCtrl.valid && busCtrl.touched }">
            <input matInput formControlName="business" type="text" npDetectFocus #ipBus="detectFocus" placeholder="Business name">
          </mat-form-field>
          <div *ngIf="busCtrl.hasError('required') && busCtrl.touched && !ipBus.isFocus ">
            <p class="err-message">Please input information here</p>
          </div>
        </div>

        <div class="form-group">
          <mat-form-field [ngClass]="{'is-invalid': titleCtrl.hasError('required') && titleCtrl.touched,
            'is-valid': titleCtrl.valid && titleCtrl.touched} ">
            <mat-select formControlName="title" npDetectFocus #ipTitle="detectFocus" placeholder="Title">
              <mat-option *ngFor="let title of titles" [value]="title.name">
                {{title.name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <div *ngIf="titleCtrl.hasError('required') && titleCtrl.touched && !ipTitle.isFocus ">
            <p class="err-message">Please input information here</p>
          </div>
        </div>

        <div class="form-group">
          <mat-form-field [ngClass]="{'is-invalid': firstNameCtrl.hasError('required') && firstNameCtrl.touched,
            'is-valid': firstNameCtrl.valid && firstNameCtrl.touched}">
            <input matInput formControlName="firstName" type="text" npDetectFocus #ipFN="detectFocus" placeholder="First name" maxlength="255">
          </mat-form-field>
          <div *ngIf="firstNameCtrl.hasError('required') && firstNameCtrl.touched &&!ipFN.isFocus" class="err-message">
            Please input information here
          </div>
          <div *ngIf="firstNameCtrl.hasError('pattern') && firstNameCtrl.touched &&!ipFN.isFocus" class="err-message">
            {{ commonMessage.ruleForUserNameField }}
          </div>
        </div>

        <div class="form-group ">
          <mat-form-field [ngClass]="{
            'is-invalid': !middleNameCtrl.valid && middleNameCtrl.touched,
            'is-valid': middleNameCtrl.valid && middleNameCtrl.touched
          }">
            <input matInput formControlName="middleName" type="text" placeholder="Middle name(s)" npDetectFocus #ipMN="detectFocus" maxlength="255"> 
            <span class="optional">Optional</span>
          </mat-form-field>
          <div *ngIf="!middleNameCtrl.valid && middleNameCtrl.touched &&!ipMN.isFocus ">
            {{ commonMessage.ruleForUserNameField }}
          </div>
        </div>

        <div class="form-group">
          <mat-form-field [ngClass]="{'is-invalid': lastNameCtrl.hasError('required') && lastNameCtrl.touched,
            'is-valid': lastNameCtrl.valid && lastNameCtrl.touched}">
            <input matInput formControlName="lastName" type="text" npDetectFocus #ipLN="detectFocus" placeholder="Last name" maxlength="255">
          </mat-form-field>
          <div *ngIf="lastNameCtrl.hasError('required') && lastNameCtrl.touched &&!ipLN.isFocus " class="err-message">
            Please input information here
          </div>
          <div *ngIf="lastNameCtrl.hasError('pattern') && lastNameCtrl.touched &&!ipLN.isFocus " class="err-message">
            {{ commonMessage.ruleForUserNameField }}
          </div>
        </div>

        <div class="form-group">
          <mat-form-field [ngClass]="{'is-invalid': !landlineCtrl.valid && landlineCtrl.touched, 'is-valid':landlineCtrl.valid && landlineCtrl.touched}">
            <input matInput formControlName="landline" type="text" npDetectFocus #ipCN="detectFocus" placeholder="Contact Number">
          </mat-form-field>
          <div *ngIf="landlineCtrl.hasError('required') && landlineCtrl.touched &&!ipCN.isFocus ">
            <p class="err-message">Please input information here</p>
          </div>
          <div *ngIf="landlineCtrl.hasError('pattern') && landlineCtrl.touched && !ipCN.isFocus">
            <p class="err-message">Invalid contact number</p>
          </div>
          <div *ngIf="!landlineCtrl.hasError('pattern') && landlineCtrl.hasError('maxlength') && landlineCtrl.touched && !ipCN.isFocus">
            <p class="err-message">Maximum of 20 characters</p>
          </div>
        </div>

        <div class="form-group">
          <mat-form-field [ngClass]="{'is-invalid': (emailCtrl.hasError('required') && emailCtrl.touched) || (emailCtrl.hasError('email') && emailCtrl.touched),
            'is-valid': emailCtrl.valid && emailCtrl.touched}">
            <input matInput formControlName="email" type="email" npDetectFocus #ipEM="detectFocus" placeholder="Email address">
          </mat-form-field>
          <div *ngIf="!emailCtrl.valid &&  emailCtrl.touched && !ipEM.isFocus">
            <p class="err-message">Please input information here</p>
          </div>
        </div>

        <div class="form-group">
          <mat-form-field [ngClass]="{'is-invalid': amountCtrl.hasError('required') && amountCtrl.touched,
                    'is-valid': amountCtrl.valid && amountCtrl.touched}">
            <input matInput type="text" npInputMask [options]="{
                        numeral: true,
                        numeralIntegerScale: 255
                      }" formControlName="amount" type="text" npDetectFocus #ipAmount="detectFocus" placeholder="Amount required">
          </mat-form-field>
          <div *ngIf="amountCtrl.hasError('required') && amountCtrl.touched && !ipAmount.isFocus">
            <p class="err-message">Please input information here</p>
          </div>
        </div>
        
        <div class="form-group" [matTooltip]="currencyBoughtTooltip" matTooltipClass="toolTip">
          <mat-form-field [ngClass]="{'is-invalid': currencyBoughtCtrl.hasError('required') && currencyBoughtCtrl.touched,
                    'is-valid': currencyBoughtCtrl.valid && currencyBoughtCtrl.touched}">
            <mat-select formControlName="currencyBought" npDetectFocus #ipCB="detectFocus" multiple placeholder="Currency bought">
              <mat-select-trigger>
                <ng-container *ngIf="!fg.get('currencyBought').value; else showCurrencyBought">
                  -----
                </ng-container>
                <ng-template #showCurrencyBought>
                  <div [innerHTML]="currencyBoughtCtrl.value | transformCurrencyMultiple : currencies : 'code'"></div>
                </ng-template>
              </mat-select-trigger>
              <mat-option *ngFor="let currency of currencies" [value]="currency.code">
                <span [class]="currency.code | flagIcon"></span>&nbsp;
                <span>{{currency.code}} </span>
              </mat-option>
            </mat-select>
          </mat-form-field>
          <div *ngIf="!currencyBoughtCtrl.valid && currencyBoughtCtrl.touched && !ipCB.isFocus">
            <p class="err-message">Please input information here</p>
          </div>
        </div>

        <div class="form-group" [matTooltip]="currencySoldTooltip" matTooltipClass="toolTip">
          <mat-form-field [ngClass]="{'is-invalid': currencySoldCtrl.hasError('required') && currencySoldCtrl.touched && !ipCS.isFocus,
                    'is-valid': currencySoldCtrl.valid && currencySoldCtrl.touched && !ipCS.isFocus}" npDetectFocus #ipCS="detectFocus">
            <mat-select formControlName="currencySold" multiple placeholder="Currency sold">
              <mat-select-trigger>
                <ng-container *ngIf="!fg.get('currencySold').value; else showCurrencySold">
                  -----
                </ng-container>
                <ng-template #showCurrencySold>
                  <div [innerHTML]="currencySoldCtrl.value | transformCurrencyMultiple : currencies : 'code'"></div>
                </ng-template>
              </mat-select-trigger>
              <mat-option *ngFor="let currency of currencies" [value]="currency.code">
                <span [class]="currency.code | flagIcon"></span>&nbsp;
                <span>{{currency.code}} </span>
              </mat-option>
            </mat-select>
          </mat-form-field>
          <div *ngIf="!currencySoldCtrl.valid && currencySoldCtrl.touched && !ipCS.isFocus">
            <p class="err-message">Please input information here</p>
          </div>
        </div>

      </div>
    </div>
    <div class="row">
      <div class="d-flex col-12">
        <p class="details-title show-cursor" (click)="showAddDetail = !showAddDetail">
          <span class="show-detail" *ngIf="!showAddDetail">+</span>
          <span class="show-detail" *ngIf="showAddDetail">-</span>
          Additional information that will aid the sale process |&nbsp;
          <span class="text text-italic">
            Optional
          </span>
        </p>
      </div>
    </div>

    <div class="row" *ngIf="showAddDetail">
      <div class="col-12 col-md-4 mx-auto">
        <div class="form-group">
          <mat-form-field [ngClass]="{'is-invalid': !phoneCtrl.valid && phoneCtrl.touched,
                'is-valid':phoneCtrl.valid && phoneCtrl.touched}">
            <input matInput type="tel" formControlName="phone" npDetectFocus #ipPN="detectFocus" placeholder="Mobile number">
          </mat-form-field>
          <div *ngIf="phoneCtrl.hasError('pattern') && phoneCtrl.touched && !ipPN.isFocus">
            <p class="err-message">Invalid phone number</p>
          </div>
          <div *ngIf="!phoneCtrl.hasError('pattern') && phoneCtrl.hasError('maxlength') && phoneCtrl.touched && !ipPN.isFocus">
            <p class="err-message">Maximum of 20 characters</p>
          </div>
        </div>

        <div class="form-group">
          <mat-form-field [ngClass]="{'is-invalid': tradeDateCtrl.hasError('required') && tradeDateCtrl.touched && !picker.opened,
                  'is-valid': tradeDateCtrl.valid && tradeDateCtrl.touched && !picker.opened}" [class.hyper-blue]="picker.opened"
            npDetectFocus #ipTD="detectFocus">
            <input matInput [matDatepicker]="picker" formControlName="tradeDate" (click)="togglePicker(picker)" placeholder="Next trade date">
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker panelClass="greengo" #picker></mat-datepicker>
          </mat-form-field>
        </div>

        <div class="form-group" *ngIf="showIndustry">
          <mat-form-field [ngClass]="{'is-valid':industryCtrl.valid && industryCtrl.touched}">
            <mat-select formControlName="industry" placeholder="Industry">
              <mat-option *ngFor="let industry of industrys" [value]="industry.name">
                {{industry.name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="form-group">
          <mat-form-field [ngClass]="{'is-valid':frequencyCtrl.valid && frequencyCtrl.touched}">
            <mat-select formControlName="frequencyNeed" [ngClass]="{'is-valid':frequencyCtrl.valid && frequencyCtrl.touched}" placeholder="Frequency of need">
              <mat-option *ngFor="let frequency of frequencies" [value]="frequency.name">
                {{frequency.name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="form-group">
          <mat-form-field [ngClass]="{'is-valid':reasonCtrl.valid && reasonCtrl.touched}">
            <mat-select formControlName="reasonPurchase" [ngClass]="{'is-valid':reasonCtrl.valid && reasonCtrl.touched}" placeholder="Reason for purchase">
              <mat-option *ngFor="let reason of reasonLists" [value]="reason.name">
                {{reason.name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="form-group" [matTooltip]="providerTooltip" matTooltipClass="toolTip">
          <mat-form-field [ngClass]="{'is-valid':currentProviderCtrl.valid && currentProviderCtrl.touched}">
            <mat-select formControlName="currentProvider" multiple placeholder="Current provider">
              <mat-option *ngFor="let provider of providerLists" [value]="provider.name">
                {{provider.name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="form-group">
          <mat-form-field [ngClass]="{'is-valid':volumeCtrl.valid && volumeCtrl.touched}">
            <input matInput formControlName="volume" type="text" npInputMask [options]="{
                numeral: true,
                numeralIntegerScale: 255
              }" placeholder="Annual volume">
          </mat-form-field>
        </div>
        <div class="form-group">
          <mat-form-field [ngClass]="{'is-valid':clientNeedCtrl.valid && clientNeedCtrl.touched}">
            <mat-select formControlName="clientNeed" placeholder="Client needs">
              <mat-option *ngFor="let clientNeed of clientLists" [value]="clientNeed.name">
                {{clientNeed.name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="form-group">
          <mat-form-field class="mat-input-area" [ngClass]="{'is-valid': noteCtrl.valid && noteCtrl.touched}">
            <textarea matInput cdkTextareaAutosize cdkAutosizeMinRows="1" cdkAutosizeMaxRows="5" formControlName="note" placeholder="Additional notes"></textarea>
          </mat-form-field>
        </div>
      </div>
    </div>
  </form>

  <div class="row mb-3" *ngIf="!isBulkUpload">
    <div class="col-md-4 offset-md-4">
      <button type="submit" class="btn btn-block btn-lg" (click)="onSubmit()" [ngClass]="{
        'btn-greengo': fg.valid,
        'btn-inactive': !fg.valid
      }" npFocusOutClicked>
        Upload
      </button>
    </div>
  </div>
</div>